import { Kontraktsomrade } from '@/domain/omrader';
import { Vegobjekt } from '@/domain/vegobjekter/Vegobjekt';
import type {
    Kontraktsomrade as ApiKontraktsomrade,
    Vegobjekt as ApiVegobjekt,
} from '@/generated/nvdb/vegobjekter/models';

type KontraktsomradeVegobjekt = Pick<ApiVegobjekt, 'id'> & {
    type: number;
};

export type KontraktsomradeApiResponse = Pick<ApiKontraktsomrade, 'navn'> &
    Partial<Pick<ApiKontraktsomrade, 'id' | 'nummer'>> & {
        type?: string;
        vegobjekt?: KontraktsomradeVegobjekt;
    };

export function transformKontraktsomrade(data: null | undefined): null;
export function transformKontraktsomrade(
    data: KontraktsomradeApiResponse
): Kontraktsomrade;
export function transformKontraktsomrade(
    data: KontraktsomradeApiResponse | null | undefined
): Kontraktsomrade | null {
    if (!data) return null;
    return new Kontraktsomrade(
        data.navn,
        data.type,
        data.id ? Vegobjekt.dummy(data.vegobjekt!.id, data.vegobjekt!.type) : undefined
    );
}

export function transformKontraktsomrader(
    kontraktsomrader: KontraktsomradeApiResponse[]
): Kontraktsomrade[] {
    return kontraktsomrader.map(ko => transformKontraktsomrade(ko));
}
